import React, { useState } from 'react'
import Chart from 'react-apexcharts'
import ApexCharts from 'apexcharts'
import { IDadosGraficosResultadosGlobaisPesquisaModel } from '../helpers/AnaliseResultadoHelper'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'

type Props = {
  dadosGraficosPesquisa: IDadosGraficosResultadosGlobaisPesquisaModel | undefined
}

const GraficoResultadosGlobais  = ({dadosGraficosPesquisa}:Props) => {  
  const [dropdownOpen, setDropdownOpen] = useState(false)
  let stackType: any = '100%'

  let options = {
    colors : dadosGraficosPesquisa?.Colors ?? [],
    series: dadosGraficosPesquisa?.Series ?? [],
    chart: {
      id: 'grafico-resultados-globais',
      stacked: true,
      stackType: stackType,
      toolbar: {
        show: false
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: dadosGraficosPesquisa?.Categories ?? [],
    },
    fill: {
      opacity: 1    
    },
    legend: {
      offsetX: 40,
      inverseOrder: true
    }
  }

  const downloadChart = (format: 'png' | 'jpeg') => {
    ApexCharts.exec('grafico-resultados-globais', 'dataURI').then((res: { imgURI: string }) => {
      const link = document.createElement('a')
      link.href = res.imgURI
      link.download = `grafico_resultados_globais.${format}`
      link.click()
    }).catch((e: unknown) => {
      console.error('Erro ao gerar download do gráfico:', e)
    })
  }
  
  return (
    <>
      <div className={`card m-0 p-0 ${dadosGraficosPesquisa ? '' : 'd-none'}`}>        
        <div className='card-body m-0 p-0'>
          <div className='row justify-content-center m-0 p-0'>

            <div className='col-lg-6 p-5 d-flex justify-content-center'>
              <img className='h-100' src={toAbsoluteUrl("/media/prolead/pesquisa/pesquisa-resultados-globais.svg")} />
            </div>

            <div className='col-lg-6 p-5 position-relative'>
              {/* Botão ☰ para download */}
              <div className="d-flex justify-content-end mb-2">
                <div className="dropdown">
                  <button
                    className="btn btn-light btn-sm dropdown-toggle"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                  >
                    ☰
                  </button>
                  <div
                    className={`dropdown-menu dropdown-menu-end ${dropdownOpen ? 'show' : ''}`}
                    style={{ minWidth: '160px' }}
                  >
                    <button className="dropdown-item" onClick={() => downloadChart('png')}>
                      Baixar PNG
                    </button>
                    <button className="dropdown-item" onClick={() => downloadChart('jpeg')}>
                      Baixar JPEG
                    </button>
                  </div>
                </div>
              </div>

              <Chart options={options} series={options.series} type="bar" height={'400px'} />
            </div>            
          </div>
        </div>        
      </div> 
    </>         
  )
}
  
export {GraficoResultadosGlobais}
